import { paymentConditionApi } from "../api";

const PaymentConditionService = {
  fetchDropdown: async () => {
    const response = await paymentConditionApi.fetchCustom('/dropdown');
    return response.data;
  },
};

export default PaymentConditionService;
